/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameExternalIdUnlinkedUsers =
  "/data_objects/:type_name/:external_id/unlinked_users" as const;
